import { formatToNumber, numberFromBytes } from "@/helpers/numberHelpers"
import DateTime from "@/helpers/date"

export default class Promotion {

    id = null
    type = 'Consumer'
    headline = null
    button_text = null
    open_in_new_tab = false
    description = null
    disclaimer = null
    _start_at = null
    _end_at = null
    url = null
    file = null
    meta = { small_image: null, large_image: null, small_image_alt: null, large_image_alt: null, show_image_inline: false }
    created_at = null
    updated_at = null

    constructor(data) {
        this.id = data?.id ?? this.id;
        this.type = data?.type ?? this.type;
        this.headline = data?.headline ?? this.headline;
        this.button_text = data?.button_text ?? this.button_text;
        this.open_in_new_tab = data?.open_in_new_tab ?? this.open_in_new_tab;
        this.description = data?.description ?? this.description;
        this.disclaimer = data?.disclaimer ?? this.disclaimer;
        this._start_at = data?.start_at ?? this._start_at;
        this._end_at = data?.end_at ?? this._end_at;
        this.url = data?.url ?? this.url;
        this.file = data?.file ?? this.file;
        this.meta = { ...this.meta, ...(data?.meta ?? this.meta) };
        this.created_at = data?.created_at ?? this.created_at;
        this.updated_at = data?.updated_at ?? this.updated_at;
        
        return this
    }

    /**
     * Get the start_at property with casting
     *
     * @param void
     * @returns {String} The start_at property
     */
    get start_at() {
        return this._start_at && new DateTime(this._start_at)
    }

    /**
     * Set the start_at property with casting
     *
     * @param {Date} value The start_at value
     * @returns void
     */
    set start_at(value) {
        this._start_at = value && new DateTime(value).toISOString()
    }

    /**
     * Get the end_at property with casting
     *
     * @param void
     * @returns {String} The end_at property
     */
    get end_at() {
        return this._end_at && new DateTime(this._end_at).toISOString()
    }

    /**
     * Set the end_at property with casting
     *
     * @param {Date} value The end_at value
     * @returns void
     */
    set end_at(value) {
        this._end_at = value && new DateTime(value).toISOString()
    }

    get start() {
        return new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: 'numeric'}).format(new Date(this.start_at))
    }

    get end() {
        return new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: 'numeric'}).format(new Date(this.end_at))
    }

    static types = [
        {
            value: 'Consumer',
            label: 'Consumer'
        },
        {
            value: 'Agent',
            label: 'Agent'
        },
        {
            value: 'NonListing',
            label: 'Non-Listing'
        }
    ];
}